import { createSlice } from "@reduxjs/toolkit"

// Initialize state safely
const initialState = (() => {
    try {
        const storedData = localStorage.getItem("agent");
        if (storedData && storedData !== "undefined" && storedData !== "null") {
            const parsedData = JSON.parse(storedData);
            return Array.isArray(parsedData) ? parsedData : [];
        }
    } catch (error) {
        console.error("Error parsing agent data from localStorage:", error);
    }
    return [];
})();

const agentSlice = createSlice({
    name: "agent",
    initialState,
    reducers: {
        getagent: (state, action) => {
            try {
                // Handle both direct payload and payload.data cases
                const newData = action.payload?.data || action.payload;
                
                // Only update if we have valid data
                if (newData) {
                    // Ensure we're working with an array
                    const dataArray = Array.isArray(newData) ? newData : [newData];
                    
                    // Store in localStorage
                    localStorage.setItem("agent", JSON.stringify(dataArray));
                    
                    // Update state by replacing it entirely
                    return dataArray;
                }
            } catch (error) {
                console.error("Error in getagent reducer:", error);
            }
            // Return existing state if anything goes wrong
            return state;
        },
    },
});

export const { getagent } = agentSlice.actions;
export default agentSlice.reducer;